export default function getAwardImageSrc(award) {
  return award.image ?
    `/public/img/awards/${award.image}` :
    `https://placeholdit.imgix.net/~text?txtsize=33&txt=${award.name}%20image&w=318&h=318`
}